// Site configuration and data - Updated from Felix Infotech Profile 2024

export const siteConfig = {
  name: 'Felix Infotech',
  tagline: 'Your Trusted Partner for Innovative IT Solutions',
  description: 'Enabling secure, scalable, and intelligent IT ecosystems with 22+ years of IT transformation excellence.',
  phone: '044 48645444',
  email: 'info@felixinfotech.com',
  website: 'www.felixinfotech.com',
  experience: '22+',
  clients: '100+',
  projects: '100+',
  employees: '100+',
  revenue: 'INR 100 Cr+',
  cagr: '5%',
};

// Office Locations
export const locations = [
  { 
    city: 'Chennai (HQ)', 
    address: 'New No. 7, Old No. 67, 3rd Main Rd, Kalaimagal Nagar, Ekkatuthangal, Chennai - 600032',
    phone: '044 48645444',
    email: 'info@felixinfotech.com'
  },
  { city: 'Mumbai', address: 'Mumbai, India', phone: '044 48645444', email: 'info@felixinfotech.com' },
  { city: 'Bangalore', address: 'Bangalore, India', phone: '044 48645444', email: 'info@felixinfotech.com' },
  { city: 'Hyderabad', address: 'Hyderabad, India', phone: '044 48645444', email: 'info@felixinfotech.com' },
  { city: 'Cochin', address: 'Cochin, India', phone: '044 48645444', email: 'info@felixinfotech.com' },
  { city: 'Coimbatore', address: 'Coimbatore, India', phone: '044 48645444', email: 'info@felixinfotech.com' },
  { city: 'Dubai', address: 'Dubai, UAE', phone: '044 48645444', email: 'info@felixinfotech.com' },
  { city: 'Singapore', address: 'Singapore', phone: '044 48645444', email: 'info@felixinfotech.com' },
];

// Strategic Customers with logos
export const strategicCustomers = [
  { name: 'Access Healthcare', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/5vk3llu1_image.png' },
  { name: 'Aditya Birla Group', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/3bcaynmz_image.png' },
  { name: 'Chola MS General Insurance', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/qhuaq2n3_image.png' },
  { name: 'Hexaware', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/hr54c0v3_image.png' },
  { name: 'Indian Bank', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/3h4fvwir_image.png' },
  { name: 'Indian Oil', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/nyb5yo0g_image.png' },
  { name: 'Larsen & Toubro', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/vh6voux1_image.png' },
  { name: 'Manappuram Finance', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/955ub884_image.png' },
  { name: 'MRPL Auto Fuel', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/v8h4xpvr_image.png' },
  { name: 'Repco Bank', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/ujb1jsge_image.png' },
  { name: 'Sun TV Network', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/vvj1x2p7_image.png' },
  { name: 'Yalamanchili', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/yd4lvxn0_image.png' },
];

// All Clients with logos
export const clients = [
  { name: 'Access Healthcare', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/5vk3llu1_image.png' },
  { name: 'Agilysys', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/c436xbp6_image.png' },
  { name: 'Ashok Leyland', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/jij3alma_image.png' },
  { name: 'Asianet', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/nr3sms9a_image.png' },
  { name: 'CashEdge', logo: 'https://images.squarespace-cdn.com/content/v1/605d0136579e9e28240650aa/1619563477477-GLNNTY68O024IPTGCA2T/Cash+Edge.jpg' },
  { name: 'Cholayil', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2VryPIXLi6VAPGZ-cfSZCAj9GlkPdDUmnkA&s' },
  { name: 'Greater Chennai Corporation', logo: 'https://assets.indiaonline.in/cg/chennai/City-Guide/corporation.jpg' },
  { name: 'Fiserv', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Fiserv_logo.svg/960px-Fiserv_logo.svg.png' },
  { name: 'Genesys', logo: 'https://seekvectorlogo.com/wp-content/uploads/2018/01/genesys-vector-logo.png' },
  { name: 'Indian Bank', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/3h4fvwir_image.png' },
  { name: 'ISRO', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Indian_Space_Research_Organisation_Logo.svg/1280px-Indian_Space_Research_Organisation_Logo.svg.png' },
  { name: 'Indian Overseas Bank', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTS9ReD82--iOgFZxZ5yK-kfDB4LV8WTbTf5w&s' },
  { name: 'Manappuram Finance Limited', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/955ub884_image.png' },
  { name: 'Maveric', logo: 'https://maveric-systems.com/wp-content/uploads/2023/09/M-_Maveric-logo.jpg' },
  { name: 'Merrill Corporation', logo: 'https://www.acg.org/sites/default/files/styles/large/public/Merrill_Corporation_Logo.jpg?itok=XAKGvLD3' },
  { name: 'Metriqe', logo: 'https://static1.squarespace.com/static/5dd4af8ffc582d7b04ad634b/t/5e4bf81f190cbb27f1644e35/1582037045954/Metriqe-logo-square.png' },
  { name: 'Murugappa', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/4n0bsf36_image.png' },
  { name: 'Nippon Paint', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/3z28rmws_image.png' },
  { name: 'Neurealm', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/ik2yqpdd_image.png' },
  { name: 'NSE', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/whgcojie_image.png' },
  { name: 'Radiant Cash Management Services', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/63c9piub_image.png' },
  { name: 'Reynolds', logo: 'https://www.reynolds-pens.com/wp-content/uploads/2021/07/reynolds-logo-footer.png' },
  { name: 'Sterling Software', logo: 'https://rainmakercloud.com/wp-content/uploads/2022/11/Sterling-logo-color.png' },
  { name: 'Sun Direct', logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f2/SD-HD-Logo.svg' },
  { name: 'TCS', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Tata_Consultancy_Services_old_logo.svg/960px-Tata_Consultancy_Services_old_logo.svg.png' },
  { name: 'Visteon', logo: 'https://upload.wikimedia.org/wikipedia/commons/3/34/Visteon_logo_%282000-2016%29.png' },
  { name: 'VIT University', logo: 'https://findlogovector.com/wp-content/uploads/2022/05/vellore-institute-of-technology-vit-logo-vector-2022.png' },
  { name: 'WABAG', logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4e/Wabag_Logo.JPG' },
  { name: 'Yalamanchili', logo: 'https://customer-assets.emergentagent.com/job_felix-update/artifacts/yd4lvxn0_image.png' },
];

// Alliance Partners with logos
export const partners = [
  { name: 'Acer', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/Acer_2011.svg/200px-Acer_2011.svg.png' },
  { name: 'Adobe', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/2h1dgeej_image.png' },
  { name: 'Akamai', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/r2wda1jf_image.png' },
  { name: 'Apple', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Apple_logo_black.svg/814px-Apple_logo_black.svg.png' },
  { name: 'AppSentinels', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/m9z4o1nk_image.png' },
  { name: 'Aruba', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/nbdftqui_image.png' },
  { name: 'ASUS', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/ASUS_Logo.svg/200px-ASUS_Logo.svg.png' },
  { name: 'Hitachi', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/es074o4p_image.png' },
  { name: 'Cato Networks', logo: 'https://www.catonetworks.com/wp-content/uploads/2022/03/cato-logo.svg' },
  { name: 'Cisco', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Cisco_logo_blue_2016.svg/200px-Cisco_logo_blue_2016.svg.png' },
  { name: 'Dell', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Dell_Logo.svg/200px-Dell_Logo.svg.png' },
  { name: 'Fortinet', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Fortinet_logo.svg/200px-Fortinet_logo.svg.png' },
  { name: 'HP', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/200px-HP_logo_2012.svg.png' },
  { name: 'Lenovo', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Lenovo_logo_2015.svg/200px-Lenovo_logo_2015.svg.png' },
  { name: 'Microsoft', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Microsoft_logo_%282012%29.svg/200px-Microsoft_logo_%282012%29.svg.png' },
  { name: 'Oracle', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Oracle_logo.svg/200px-Oracle_logo.svg.png' },
  { name: 'BeyondTrust', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/53xuk8em_image.png' },
  { name: 'Commvault', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/iwumwigw_image.png' },
  { name: 'ExaGrid', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/fywytp2f_image.png' },
  { name: 'FireMon', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/8ak5e2i2_image.png' },
  { name: 'Forcepoint', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/nwkm6i7b_image.png' },
  { name: 'Forescout', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/a57eodsw_image.png' },
  { name: 'Gigamon', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/zq2ku35z_image.png' },
  { name: 'Guardicore', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/zrckggav_image.png' },
  { name: 'HP', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/200px-HP_logo_2012.svg.png' },
  { name: 'Infoblox', logo: 'https://www.infoblox.com/wp-content/uploads/infoblox-logo.svg' },
  { name: 'K7 Security', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/hzm80wir_image.png' },
  { name: 'LinkShadow', logo: 'https://linkshadow.com/images/logo.svg' },
  { name: 'Lenovo', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Lenovo_logo_2015.svg/200px-Lenovo_logo_2015.svg.png' },
  { name: 'Micro Focus', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Micro_Focus_logo.svg/200px-Micro_Focus_logo.svg.png' },
  { name: 'Microsoft', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Microsoft_logo_%282012%29.svg/200px-Microsoft_logo_%282012%29.svg.png' },
  { name: 'One Identity', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/mn3wyha4_image.png' },
  { name: 'Oracle', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Oracle_logo.svg/200px-Oracle_logo.svg.png' },
  { name: 'Palo Alto Networks', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/thbn4t2p_image.png' },
  { name: 'Prophaze', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/nu2oanml_image.png' },
  { name: 'Proofpoint', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/8xdshnxj_image.png' },
  { name: 'Protectt.ai', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/kib48tp9_image.png' },
  { name: 'Pure Storage', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/xw2jww78_image.png' },
  { name: 'Qualys', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/39w36t5g_image.png' },
  { name: 'Scalefusion', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/onx9s2we_image.png' },
  { name: 'Securden', logo: 'https://www.securden.com/images/securden-logo.svg' },
  { name: 'Seclore', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/qc8d5cem_image.png' },
  { name: 'SentinelOne', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/51cfgukk_image.png' },
  { name: 'Sophos', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/fhs6xzo8_image.png' },
  { name: 'Thales', logo: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/ynouzsgx_image.png' },
  { name: 'TP-Link', logo: 'https://logo.wine/a/logo/TP-Link/TP-Link-Logo.wine.svg' },
];

// 4 Main Solutions/Services
export const services = {
  compute: {
    id: 'compute',
    title: 'Compute',
    subtitle: 'Infrastructure Solutions',
    icon: 'Monitor',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80',
    gradient: 'from-[#0066CC] to-[#004499]',
    description: 'Enterprise-grade compute infrastructure including servers, storage, cloud solutions, and hyper-converged systems for modern data centers.',
    longDescription: 'Felix Infotech delivers comprehensive compute solutions that form the backbone of your IT infrastructure. From high-performance servers to scalable storage systems, we help organizations build resilient and efficient data centers.',
    stats: [
      { value: '99.99%', label: 'Uptime SLA' },
      { value: '100+', label: 'DC Projects' },
      { value: '24/7', label: 'Support' },
      { value: '5721', label: 'Branches Served' },
    ],
    subServices: [
      {
        id: 'servers',
        title: 'Servers',
        description: 'Enterprise servers from leading vendors for mission-critical workloads.',
        longDescription: 'Deploy high-performance servers optimized for your business needs. We offer rack, tower, and blade servers from HP, Dell, Lenovo, and other leading manufacturers.\n\nOur server solutions include:\n\n• Rack Servers for data center deployments\n• Tower Servers for branch offices\n• Blade Servers for high-density computing\n• GPU Servers for AI/ML workloads',
        features: ['HP ProLiant Servers', 'Dell PowerEdge Servers', 'Lenovo ThinkSystem', 'Server Virtualization', 'High Availability Clusters'],
        benefits: ['Improved performance', 'Reduced downtime', 'Scalable architecture', 'Energy efficient'],
      },
      {
        id: 'laptops-desktops',
        title: 'Laptops & Desktops',
        description: 'Business laptops and desktops for enterprise productivity.',
        longDescription: 'Equip your workforce with reliable business laptops and desktops from top brands. We provide end-to-end procurement, deployment, and support services.\n\nOur offerings include:\n\n• Business Laptops from HP, Dell, Lenovo, ASUS, Acer\n• Desktop Workstations for power users\n• Thin Clients for VDI environments\n• Apple MacBooks for creative teams',
        features: ['HP EliteBook/ProBook', 'Dell Latitude/Precision', 'Lenovo ThinkPad', 'Apple MacBook', 'ASUS/Acer Business Series'],
        benefits: ['Bulk procurement discounts', 'Warranty management', 'Asset lifecycle management', 'Pre-configured deployment'],
      },
      {
        id: 'storage',
        title: 'Storage',
        description: 'Enterprise storage solutions for data protection and performance.',
        longDescription: 'Secure and scalable storage solutions to manage your growing data needs. We implement SAN, NAS, and object storage systems from industry leaders.\n\nStorage solutions we provide:\n\n• SAN Storage for block-level access\n• NAS Storage for file sharing\n• All-Flash Arrays for high performance\n• Hybrid Storage for cost optimization\n• Object Storage for unstructured data',
        features: ['Pure Storage', 'Dell EMC', 'NetApp', 'Hitachi', 'HP Storage'],
        benefits: ['Data deduplication', 'Compression', 'Snapshots & replication', 'Tiered storage'],
      },
      {
        id: 'hyper-convergence',
        title: 'Hyper Convergence',
        description: 'Integrated compute, storage, and networking in a single platform.',
        longDescription: 'Simplify your data center with hyper-converged infrastructure (HCI) that combines compute, storage, and networking in a single solution.\n\nBenefits of HCI:\n\n• Simplified management through single console\n• Linear scalability by adding nodes\n• Reduced data center footprint\n• Built-in data protection\n• Lower total cost of ownership',
        features: ['Nutanix', 'VMware vSAN', 'Dell VxRail', 'HPE SimpliVity', 'Microsoft Azure Stack HCI'],
        benefits: ['Reduced complexity', 'Faster deployment', 'Easy scaling', 'Lower TCO'],
      },
      {
        id: 'cloud',
        title: 'Cloud',
        description: 'Public, private, and hybrid cloud solutions for digital transformation.',
        longDescription: 'Accelerate your cloud journey with our comprehensive cloud services. We help organizations migrate, optimize, and manage cloud environments.\n\nCloud services include:\n\n• Public Cloud (AWS, Azure, GCP)\n• Private Cloud deployment\n• Hybrid Cloud architecture\n• Cloud migration services\n• Cloud cost optimization',
        features: ['AWS', 'Microsoft Azure', 'Google Cloud', 'Private Cloud', 'Hybrid Cloud'],
        benefits: ['Scalability on demand', 'Pay-as-you-go model', 'Global availability', 'Disaster recovery'],
      },
      {
        id: 'colocation',
        title: 'Co-Location',
        description: 'Secure data center colocation services for your infrastructure.',
        longDescription: 'Host your servers in our Tier-III compliant data centers with 24/7 security, power backup, and network connectivity.\n\nColocation features:\n\n• Tier-III data center facilities\n• Redundant power and cooling\n• Multiple network carriers\n• Physical security and access control\n• Remote hands support',
        features: ['Tier-III DC', 'Redundant Power', 'Multiple Carriers', '24/7 Security', 'Remote Hands'],
        benefits: ['Reduced capital expense', 'Better connectivity', 'Physical security', 'Compliance ready'],
      },
      {
        id: 'backup',
        title: 'Backup',
        description: 'Enterprise backup and disaster recovery solutions.',
        longDescription: 'Protect your critical data with comprehensive backup and disaster recovery solutions. We implement backup strategies that ensure business continuity.\n\nBackup solutions:\n\n• On-premise backup appliances\n• Cloud backup services\n• Disaster recovery as a service (DRaaS)\n• Backup monitoring and management\n• Data archival solutions',
        features: ['Commvault', 'Veeam', 'Dell EMC', 'ExaGrid', 'Cloud Backup'],
        benefits: ['Data protection', 'Fast recovery', 'Compliance', 'Ransomware protection'],
      },
    ],
    faqs: [
      { question: 'What server brands do you support?', answer: 'We are authorized partners for HP, Dell, Lenovo, Hitachi, and other leading server manufacturers.' },
      { question: 'Do you provide installation services?', answer: 'Yes, we provide end-to-end services including site survey, installation, configuration, and ongoing support.' },
      { question: 'What is the typical deployment timeline?', answer: 'Deployment timelines vary based on project scope. Simple deployments take 1-2 weeks while complex DC projects may take 4-8 weeks.' },
    ],
  },
  network: {
    id: 'network',
    title: 'Network & Security',
    subtitle: 'Cybersecurity Solutions',
    icon: 'Shield',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80',
    gradient: 'from-[#0066CC] to-[#003366]',
    description: 'Comprehensive network infrastructure and cybersecurity solutions to protect your enterprise from evolving threats.',
    longDescription: 'Felix Infotech provides end-to-end network and security solutions to build secure, reliable, and high-performance network infrastructure. Our certified security professionals help protect your organization from cyber threats.',
    stats: [
      { value: '25+', label: 'Security Certified Pros' },
      { value: '20+', label: 'Security Partners' },
      { value: '24/7', label: 'SOC Monitoring' },
      { value: '100+', label: 'Security Projects' },
    ],
    subServices: [
      {
        id: 'switches-routers',
        title: 'Switches & Routers',
        description: 'Enterprise networking equipment for reliable connectivity.',
        longDescription: 'Build robust network infrastructure with enterprise-grade switches and routers from leading vendors.\n\nNetworking solutions:\n\n• Core and distribution switches\n• Access layer switches\n• Data center switches\n• Enterprise routers\n• SD-WAN solutions',
        features: ['Cisco', 'Aruba', 'Juniper', 'Fortinet', 'Dell Networking'],
        benefits: ['High throughput', 'Low latency', 'Advanced QoS', 'Network automation'],
      },
      {
        id: 'wireless',
        title: 'Access Points',
        description: 'Enterprise wireless solutions for seamless connectivity.',
        longDescription: 'Deploy secure and high-performance wireless networks across your organization.\n\nWireless solutions:\n\n• Indoor and outdoor access points\n• Wireless controllers\n• Cloud-managed WiFi\n• WiFi 6/6E solutions\n• Guest WiFi portals',
        features: ['Aruba', 'Cisco Meraki', 'Fortinet', 'Ruckus', 'UniFi'],
        benefits: ['Seamless roaming', 'High density support', 'Centralized management', 'Guest access'],
      },
      {
        id: 'ngfw',
        title: 'Next-Gen Firewall (NGFW)',
        description: 'Advanced firewall protection with application awareness and threat prevention.',
        longDescription: 'Protect your network perimeter with next-generation firewalls that provide advanced threat protection.\n\nNGFW capabilities:\n\n• Application-level inspection\n• Intrusion prevention (IPS)\n• URL filtering\n• SSL inspection\n• Sandboxing',
        features: ['Palo Alto Networks', 'Fortinet FortiGate', 'Cisco Firepower', 'Check Point', 'Sophos'],
        benefits: ['Advanced threat protection', 'Application control', 'User-based policies', 'Centralized management'],
      },
      {
        id: 'email-security',
        title: 'Email Security',
        description: 'Protect against phishing, spam, and email-borne threats.',
        longDescription: 'Secure your email communication with advanced email security solutions.\n\nEmail security features:\n\n• Anti-phishing protection\n• Spam filtering\n• Malware detection\n• Data loss prevention\n• Email encryption',
        features: ['Proofpoint', 'Forcepoint', 'Microsoft Defender', 'Cisco Email Security', 'Mimecast'],
        benefits: ['Phishing protection', 'Spam reduction', 'Compliance', 'Brand protection'],
      },
      {
        id: 'edr-xdr',
        title: 'EDR / XDR / NDR',
        description: 'Endpoint, extended, and network detection and response solutions.',
        longDescription: 'Advanced threat detection and response across endpoints, networks, and cloud environments.\n\nDetection & Response:\n\n• EDR - Endpoint Detection & Response\n• XDR - Extended Detection & Response\n• NDR - Network Detection & Response\n• Automated threat hunting\n• Incident response',
        features: ['SentinelOne', 'CrowdStrike', 'Palo Alto Cortex', 'Microsoft Defender', 'Fortinet FortiEDR'],
        benefits: ['Real-time threat detection', 'Automated response', 'Forensic analysis', 'Threat intelligence'],
      },
      {
        id: 'siem-soar',
        title: 'SIEM / SOAR / UEBA',
        description: 'Security information management and automated response.',
        longDescription: 'Centralize security monitoring with SIEM and automate response with SOAR platforms.\n\nSecurity operations:\n\n• SIEM - Security Information & Event Management\n• SOAR - Security Orchestration, Automation & Response\n• UEBA - User & Entity Behavior Analytics\n• Log management\n• Compliance reporting',
        features: ['Splunk', 'Microsoft Sentinel', 'IBM QRadar', 'LogRhythm', 'Securonix'],
        benefits: ['Centralized visibility', 'Automated playbooks', 'Faster response', 'Compliance'],
      },
      {
        id: 'dlp',
        title: 'Data Leakage Prevention',
        description: 'Prevent unauthorized data exfiltration and ensure compliance.',
        longDescription: 'Protect sensitive data from unauthorized access and leakage with comprehensive DLP solutions.\n\nDLP capabilities:\n\n• Endpoint DLP\n• Network DLP\n• Cloud DLP\n• Data classification\n• Policy enforcement',
        features: ['Forcepoint DLP', 'Symantec DLP', 'Microsoft Purview', 'Digital Guardian', 'Seclore'],
        benefits: ['Data protection', 'Compliance', 'Visibility', 'Policy enforcement'],
      },
      {
        id: 'sase-sdwan',
        title: 'SASE / SD-WAN',
        description: 'Secure access service edge and software-defined WAN solutions.',
        longDescription: 'Modernize your WAN with SD-WAN and secure access with SASE architecture.\n\nSASE/SD-WAN benefits:\n\n• Secure remote access\n• Optimized cloud connectivity\n• Zero trust network access\n• Integrated security\n• Centralized management',
        features: ['Cato Networks', 'Fortinet SD-WAN', 'Cisco SD-WAN', 'Palo Alto Prisma', 'Zscaler'],
        benefits: ['Cost reduction', 'Better performance', 'Security integration', 'Cloud optimization'],
      },
      {
        id: 'mfa',
        title: 'Multi-Factor Authentication',
        description: 'Strengthen access security with MFA solutions.',
        longDescription: 'Implement robust authentication to prevent unauthorized access.\n\nMFA solutions:\n\n• Hardware tokens\n• Soft tokens\n• Biometric authentication\n• Push notifications\n• Passwordless authentication',
        features: ['Microsoft Authenticator', 'Duo Security', 'RSA SecurID', 'Thales', 'One Identity'],
        benefits: ['Stronger security', 'Reduced risk', 'Compliance', 'User convenience'],
      },
      {
        id: 'pam',
        title: 'Privileged Access Management',
        description: 'Secure and manage privileged accounts across your organization.',
        longDescription: 'Control and audit privileged access to critical systems and data.\n\nPAM capabilities:\n\n• Privileged password vault\n• Session recording & monitoring\n• Just-in-time access\n• Privileged threat analytics\n• Least privilege enforcement',
        features: ['BeyondTrust', 'CyberArk', 'One Identity', 'Securden', 'Thycotic'],
        benefits: ['Reduced attack surface', 'Compliance', 'Audit trail', 'Zero trust access'],
      },
      {
        id: 'encryption',
        title: 'Encryption & Key Management',
        description: 'Protect data at rest and in transit with enterprise encryption.',
        longDescription: 'Comprehensive encryption solutions for data protection.\n\nEncryption services:\n\n• Database encryption\n• File & folder encryption\n• Full disk encryption\n• Key lifecycle management\n• HSM integration',
        features: ['Thales CipherTrust', 'Vormetric', 'IBM Guardium', 'AWS KMS', 'Azure Key Vault'],
        benefits: ['Data protection', 'Regulatory compliance', 'Secure key management', 'Centralized control'],
      },
      {
        id: 'nac',
        title: 'NAC / Micro-Segmentation',
        description: 'Network access control and zero-trust segmentation.',
        longDescription: 'Control network access and implement micro-segmentation.\n\nNAC capabilities:\n\n• Device profiling & visibility\n• Policy-based access control\n• Guest network management\n• IoT device security\n• Micro-segmentation',
        features: ['Forescout', 'Cisco ISE', 'Aruba ClearPass', 'Guardicore', 'Illumio'],
        benefits: ['Zero trust network', 'Lateral movement prevention', 'IoT security', 'Compliance'],
      },
      {
        id: 'firewall-mgmt',
        title: 'Firewall Management',
        description: 'Centralized firewall policy management and compliance.',
        longDescription: 'Manage firewall policies across multi-vendor environments.\n\nFirewall management:\n\n• Policy change management\n• Rule optimization\n• Compliance reporting\n• Risk analysis\n• Multi-vendor support',
        features: ['FireMon', 'AlgoSec', 'Tufin', 'Skybox', 'RedSeal'],
        benefits: ['Policy visibility', 'Reduced complexity', 'Compliance automation', 'Risk reduction'],
      },
      {
        id: 'drm',
        title: 'DRM / EDRM',
        description: 'Digital rights management for document and data protection.',
        longDescription: 'Protect sensitive documents and intellectual property.\n\nDRM capabilities:\n\n• Document encryption\n• Access control & tracking\n• Watermarking\n• Remote revocation\n• Classification-based protection',
        features: ['Seclore', 'Microsoft AIP', 'Vera', 'Fasoo', 'Intralinks'],
        benefits: ['IP protection', 'Document tracking', 'Collaboration security', 'Compliance'],
      },
      {
        id: 'casb',
        title: 'CASB',
        description: 'Cloud Access Security Broker for SaaS security.',
        longDescription: 'Secure cloud application usage and data.\n\nCASB features:\n\n• Shadow IT discovery\n• Cloud DLP\n• Threat protection\n• Compliance monitoring\n• User behavior analytics',
        features: ['Microsoft Defender', 'Netskope', 'McAfee MVISION', 'Symantec CloudSOC', 'Forcepoint'],
        benefits: ['Cloud visibility', 'Data protection', 'Threat prevention', 'Compliance'],
      },
      {
        id: 'uem',
        title: 'Mobile Security (UEM)',
        description: 'Unified Endpoint Management for mobile device security.',
        longDescription: 'Secure and manage mobile devices across your organization.\n\nUEM capabilities:\n\n• Mobile device management\n• Mobile application management\n• Container security\n• Remote wipe\n• Compliance enforcement',
        features: ['Scalefusion', 'Microsoft Intune', 'VMware Workspace ONE', 'MobileIron', 'Jamf'],
        benefits: ['BYOD security', 'App management', 'Data protection', 'Remote management'],
      },
      {
        id: 'waf',
        title: 'WAF / API Security',
        description: 'Web Application Firewall and API protection.',
        longDescription: 'Protect web applications and APIs from attacks.\n\nWAF/API security:\n\n• OWASP Top 10 protection\n• Bot management\n• API gateway security\n• DDoS protection\n• Rate limiting',
        features: ['Prophaze', 'AppSentinels', 'Cloudflare', 'Akamai', 'AWS WAF'],
        benefits: ['Application protection', 'API security', 'Bot mitigation', 'DDoS defense'],
      },
      {
        id: 'vapt',
        title: 'VAPT',
        description: 'Vulnerability Assessment and Penetration Testing.',
        longDescription: 'Identify security weaknesses before attackers do.\n\nVAPT services:\n\n• Network penetration testing\n• Web application testing\n• Mobile app testing\n• Cloud security assessment\n• Red team exercises',
        features: ['Qualys', 'Nessus', 'Burp Suite', 'Metasploit', 'Cobalt Strike'],
        benefits: ['Risk identification', 'Compliance', 'Security validation', 'Remediation guidance'],
      },
      {
        id: 'vulnerability-mgmt',
        title: 'Vulnerability Management',
        description: 'Continuous vulnerability scanning and remediation.',
        longDescription: 'Ongoing vulnerability identification and management.\n\nVulnerability management:\n\n• Continuous scanning\n• Asset discovery\n• Prioritization\n• Remediation tracking\n• Compliance reporting',
        features: ['Qualys VMDR', 'Rapid7 InsightVM', 'Tenable.io', 'CrowdStrike Falcon', 'Microsoft Defender'],
        benefits: ['Continuous visibility', 'Risk prioritization', 'Automated workflows', 'Compliance'],
      },
    ],
    faqs: [
      { question: 'What security certifications do your team hold?', answer: 'Our team holds certifications including CISSP, CEH, CCNP Security, Fortinet NSE, Palo Alto PCNSE, and more.' },
      { question: 'Do you provide 24/7 SOC services?', answer: 'Yes, we offer round-the-clock Security Operations Center monitoring and incident response.' },
      { question: 'Can you help with compliance requirements?', answer: 'Yes, we help organizations achieve compliance with ISO 27001, PCI-DSS, GDPR, and other standards.' },
    ],
  },
  monitoring: {
    id: 'monitoring',
    title: 'Monitoring',
    subtitle: 'Infrastructure Monitoring',
    icon: 'Monitor',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
    gradient: 'from-[#0066CC] to-[#0088DD]',
    description: 'Comprehensive IT infrastructure monitoring solutions for proactive issue detection and resolution.',
    longDescription: 'Felix Infotech provides end-to-end monitoring solutions that give you complete visibility into your IT infrastructure. Our monitoring services help prevent downtime and optimize performance.',
    stats: [
      { value: '24/7', label: 'Monitoring' },
      { value: '99.9%', label: 'Uptime' },
      { value: '<15min', label: 'Alert Response' },
      { value: '100+', label: 'Monitored Clients' },
    ],
    subServices: [
      {
        id: 'network-monitoring',
        title: 'Network Monitoring',
        description: 'Real-time network performance monitoring and alerting.',
        longDescription: 'Monitor your network infrastructure 24/7 for performance, availability, and security.\n\nNetwork monitoring includes:\n\n• Bandwidth utilization\n• Latency and packet loss\n• Device health monitoring\n• Traffic analysis\n• Anomaly detection',
        features: ['SNMP Monitoring', 'NetFlow Analysis', 'Threshold Alerts', 'Topology Mapping', 'SLA Reporting'],
        benefits: ['Proactive issue detection', 'Performance optimization', 'Capacity planning', 'Reduced downtime'],
      },
      {
        id: 'server-monitoring',
        title: 'Server & Storage Monitoring',
        description: 'Comprehensive server and storage health monitoring.',
        longDescription: 'Monitor server and storage infrastructure for optimal performance and availability.\n\nServer monitoring covers:\n\n• CPU, memory, disk utilization\n• Process and service monitoring\n• Hardware health (fans, temperature, PSU)\n• Storage capacity and IOPS\n• Virtual machine monitoring',
        features: ['Hardware Health', 'Performance Metrics', 'Capacity Alerts', 'VM Monitoring', 'Custom Dashboards'],
        benefits: ['Prevent outages', 'Capacity planning', 'Performance tuning', 'Cost optimization'],
      },
      {
        id: 'database-monitoring',
        title: 'Database Monitoring',
        description: 'Database performance and availability monitoring.',
        longDescription: 'Ensure database performance and availability with comprehensive monitoring.\n\nDatabase monitoring includes:\n\n• Query performance analysis\n• Connection pool monitoring\n• Deadlock detection\n• Replication status\n• Backup verification',
        features: ['Oracle', 'SQL Server', 'MySQL', 'PostgreSQL', 'MongoDB'],
        benefits: ['Query optimization', 'Issue prevention', 'Performance tuning', 'Compliance'],
      },
      {
        id: 'application-monitoring',
        title: 'Application Monitoring',
        description: 'End-to-end application performance monitoring.',
        longDescription: 'Monitor application performance and user experience across your technology stack.\n\nApplication monitoring:\n\n• Response time tracking\n• Error rate monitoring\n• Transaction tracing\n• User experience metrics\n• Synthetic monitoring',
        features: ['APM Tools', 'Real User Monitoring', 'Synthetic Testing', 'Log Analysis', 'Alerting'],
        benefits: ['Better user experience', 'Faster troubleshooting', 'Performance optimization', 'SLA compliance'],
      },
      {
        id: 'soc-monitoring',
        title: 'Security Operations Center (SOC)',
        description: '24/7 security monitoring and incident response.',
        longDescription: 'Round-the-clock security monitoring with expert analysts to protect your organization.\n\nSOC services:\n\n• 24/7 threat monitoring\n• Incident detection and response\n• Threat intelligence\n• Vulnerability management\n• Compliance reporting',
        features: ['24/7 Monitoring', 'Threat Detection', 'Incident Response', 'Threat Intel', 'Compliance'],
        benefits: ['Continuous protection', 'Expert analysis', 'Faster response', 'Reduced risk'],
      },
      {
        id: 'wireless-monitoring',
        title: 'Wireless Monitoring',
        description: 'WiFi network performance and security monitoring.',
        longDescription: 'Monitor wireless network performance, coverage, and security.\n\nWireless monitoring includes:\n\n• Signal strength mapping\n• Client connectivity\n• Rogue AP detection\n• Interference analysis\n• Performance optimization',
        features: ['Coverage Analysis', 'Client Tracking', 'Rogue Detection', 'Performance Metrics', 'Heat Maps'],
        benefits: ['Optimal coverage', 'Security', 'User experience', 'Capacity planning'],
      },
    ],
    faqs: [
      { question: 'What monitoring tools do you use?', answer: 'We use industry-leading tools including SolarWinds, PRTG, Nagios, Zabbix, and vendor-specific solutions.' },
      { question: 'Can monitoring be customized?', answer: 'Yes, we customize monitoring dashboards, alerts, and reports based on your specific requirements.' },
      { question: 'How quickly do you respond to alerts?', answer: 'Our NOC team responds to critical alerts within 15 minutes, 24/7.' },
    ],
  },
  services: {
    id: 'services',
    title: 'Services',
    subtitle: 'Professional IT Services',
    icon: 'Code',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80',
    gradient: 'from-[#0066CC] to-[#0055AA]',
    description: 'Professional IT services including security assessments, compliance, training, and managed services.',
    longDescription: 'Felix Infotech offers comprehensive professional services to help organizations optimize their IT operations, achieve compliance, and build internal capabilities through training and consulting.',
    stats: [
      { value: '100+', label: 'ITSM Engineers' },
      { value: '25+', label: 'Security Pros' },
      { value: 'ISO', label: '27001 Certified' },
      { value: '22+', label: 'Years Experience' },
    ],
    subServices: [
      {
        id: 'vapt',
        title: 'VAPT',
        description: 'Vulnerability Assessment and Penetration Testing services.',
        longDescription: 'Identify and remediate security vulnerabilities before attackers exploit them.\n\nVAPT services:\n\n• Network penetration testing\n• Web application testing\n• Mobile application testing\n• API security testing\n• Social engineering assessments',
        features: ['Network VAPT', 'Web App Testing', 'Mobile Testing', 'API Testing', 'Red Team'],
        benefits: ['Identify vulnerabilities', 'Compliance', 'Risk reduction', 'Security validation'],
      },
      {
        id: 'compliance-audit',
        title: 'Network & Security Compliance Audit',
        description: 'Comprehensive security and compliance auditing services.',
        longDescription: 'Ensure your IT infrastructure meets security standards and compliance requirements.\n\nAudit services:\n\n• Network security audit\n• Firewall rule review\n• Configuration assessment\n• Compliance gap analysis\n• Remediation guidance',
        features: ['ISO 27001', 'PCI-DSS', 'GDPR', 'SOC 2', 'HIPAA'],
        benefits: ['Compliance achievement', 'Risk identification', 'Best practices', 'Audit readiness'],
      },
      {
        id: 'security-training',
        title: 'Security Awareness Training',
        description: 'Employee security awareness and training programs.',
        longDescription: 'Build a security-conscious culture with comprehensive training programs.\n\nTraining programs:\n\n• Phishing awareness\n• Password security\n• Social engineering\n• Data protection\n• Incident reporting',
        features: ['Phishing Simulations', 'Interactive Modules', 'Assessments', 'Reporting', 'Customization'],
        benefits: ['Reduced human risk', 'Compliance', 'Security culture', 'Incident prevention'],
      },
      {
        id: 'iso-training',
        title: 'ISO 27001 Training & Certification',
        description: 'ISO 27001 implementation and certification support.',
        longDescription: 'Achieve ISO 27001 certification with our expert guidance and training.\n\nISO 27001 services:\n\n• Gap analysis\n• ISMS implementation\n• Documentation support\n• Internal audit training\n• Certification support',
        features: ['Gap Analysis', 'Implementation', 'Documentation', 'Training', 'Certification'],
        benefits: ['Certification', 'Improved security', 'Customer trust', 'Competitive advantage'],
      },
      {
        id: 'grc',
        title: 'GRC Compliance Training & Certification',
        description: 'Governance, Risk, and Compliance training and consulting.',
        longDescription: 'Build robust GRC capabilities within your organization.\n\nGRC services:\n\n• Risk management frameworks\n• Policy development\n• Compliance management\n• Audit management\n• Training programs',
        features: ['Risk Assessment', 'Policy Framework', 'Compliance Tracking', 'Audit Support', 'Training'],
        benefits: ['Better governance', 'Risk management', 'Compliance', 'Operational efficiency'],
      },
      {
        id: 'cloud-services',
        title: 'Cloud Services',
        description: 'Cloud migration, optimization, and managed cloud services.',
        longDescription: 'Accelerate your cloud journey with our comprehensive cloud services.\n\nCloud services include:\n\n• Cloud assessment and strategy\n• Migration planning and execution\n• Cloud optimization\n• Managed cloud services\n• Multi-cloud management',
        features: ['AWS', 'Azure', 'GCP', 'Migration', 'Optimization'],
        benefits: ['Cost optimization', 'Scalability', 'Agility', 'Innovation'],
      },
      {
        id: 'amc',
        title: 'Hardware & Network AMC',
        description: 'Annual maintenance contracts for IT infrastructure.',
        longDescription: 'Ensure optimal performance and availability of your IT infrastructure with our AMC services.\n\nAMC coverage:\n\n• Preventive maintenance\n• Break-fix support\n• Spare parts management\n• 24/7 helpdesk\n• On-site support',
        features: ['Preventive Maintenance', 'Break-Fix', 'Spares', '24/7 Support', 'SLA-based'],
        benefits: ['Reduced downtime', 'Predictable costs', 'Expert support', 'Extended life'],
      },
      {
        id: 'fms',
        title: 'Facility Management Services',
        description: 'IT facility management and on-site support services.',
        longDescription: 'Comprehensive facility management services for your IT infrastructure.\n\nFMS services:\n\n• On-site engineers (16x7x365)\n• Data center operations\n• Infrastructure management\n• Vendor coordination\n• Reporting and SLAs',
        features: ['On-site Engineers', 'DC Operations', 'Infra Management', 'Vendor Management', 'SLA Reporting'],
        benefits: ['Dedicated support', 'Reduced burden', 'Expertise', 'Cost efficiency'],
      },
    ],
    faqs: [
      { question: 'What certifications do your engineers hold?', answer: 'Our engineers hold certifications including CISSP, CEH, CCNA/CCNP, ITIL, and vendor-specific certifications.' },
      { question: 'Do you provide on-site support?', answer: 'Yes, we provide dedicated on-site engineers as part of our FMS and AMC services.' },
      { question: 'Can you help with ISO certification?', answer: 'Yes, we provide complete ISO 27001 implementation support from gap analysis to certification.' },
    ],
  },
};

// Case Studies
export const caseStudies = [
  {
    id: 'banking-dc',
    title: 'Data Center Solutions for Banking Industry',
    client: 'Nationalized Bank',
    industry: 'Banking',
    stats: { branches: '5721', users: '30000+' },
    challenge: 'The bank faced critical challenges including frequent server shutdowns, network intermittency issues, capacity limitations, and inadequate disaster recovery setup.',
    solution: 'Felix Infotech implemented an enriched DC/DR setup with seamless data migration and 24/7 engineering support to ensure uninterrupted banking operations.',
    results: [
      'Enriched DC/DR infrastructure',
      'Seamless data migration',
      '24/7 dedicated engineering support',
      'Zero unplanned downtime',
    ],
  },
  {
    id: 'banking-virtualization',
    title: 'Virtualization Solutions for Banking Industry',
    client: 'Nationalized Bank',
    industry: 'Banking',
    stats: { branches: '5721', users: '30000+', availability: '16x7x365' },
    challenge: 'Challenges in server manageability, hardware maintenance, and compliance requirements affecting operational efficiency.',
    solution: 'Deployed comprehensive virtualization infrastructure with VMware, remote user connectivity, and FMS engineer deployment for continuous support.',
    results: [
      'Remote user connectivity enabled',
      'FMS engineer deployment (16x7x365)',
      'VMware infrastructure implementation',
      'Improved compliance posture',
    ],
  },
  {
    id: 'isp-solutions',
    title: 'Simplifying Solutions for ISP Customer',
    client: "India's Largest MSO and ISP (Kerala)",
    industry: 'Telecom / ISP',
    stats: { revenue: '₹250 Cr', districts: '14', lcos: '4000+', subscribers: '30L+' },
    challenge: 'Network intermittency issues and complex customer migration requirements across multiple districts.',
    solution: 'Implemented IP network switches, FTTH connectivity solutions, and comprehensive network security across 14 districts.',
    results: [
      'ISP NOC implementation across 14 districts',
      'Support for 4000+ LCOs serving 30L+ subscribers',
      'FTTH connectivity deployment',
      'Enhanced network security',
    ],
  },
  {
    id: 'private-cloud',
    title: 'Private Cloud Setup for Software Company',
    client: '$160M Indian Software Company',
    industry: 'Software / IT',
    stats: { revenue: '$160M', offices: '13', servers: '75', applications: '50+' },
    challenge: 'On-premise infrastructure chaos, escalating IT costs, and need to modernize 75 servers supporting 50+ proprietary applications across 13 APAC offices.',
    solution: 'Executed seamless private cloud transition with hybrid integration and real-time monitoring capabilities.',
    results: [
      'Seamless private cloud transition',
      'Hybrid cloud integration',
      'Real-time monitoring implementation',
      'Reduced IT infrastructure costs',
    ],
  },
];

// FAQs
export const faqs = [
  { question: 'How many years of experience does Felix Infotech have?', answer: 'Felix Infotech has 22+ years of IT transformation excellence, serving enterprises across India and internationally.' },
  { question: 'What industries do you serve?', answer: 'We serve diverse industries including Banking, Insurance, Manufacturing, Healthcare, Education, Government, IT/Software, Telecom, and more.' },
  { question: 'What certifications does Felix Infotech hold?', answer: 'We are ISO 9001 and ISO 27001 certified, ensuring quality management and information security best practices.' },
  { question: 'How many certified professionals do you have?', answer: 'We have 100+ certified ITSM implementation engineers and 25+ cybersecurity certified professionals.' },
  { question: 'What are your office locations?', answer: 'We have offices in Chennai (HQ), Mumbai, Bangalore, Hyderabad, Cochin, Coimbatore, Dubai, and Singapore.' },
  { question: 'Do you provide 24/7 support?', answer: 'Yes, we provide round-the-clock support for critical infrastructure and SOC monitoring services.' },
];

// Blog posts (keeping existing)
export const blogPosts = [
  {
    id: 'cybersecurity-trends-2024',
    title: 'Top Cybersecurity Trends to Watch in 2024',
    excerpt: 'Explore the latest cybersecurity trends including AI-powered threats, zero trust architecture, and cloud security challenges.',
    category: 'Cyber Security',
    author: 'Felix Security Team',
    date: '2024-01-15',
    readTime: '5 min',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80',
  },
  {
    id: 'cloud-migration-guide',
    title: 'Complete Guide to Enterprise Cloud Migration',
    excerpt: 'A comprehensive guide to planning and executing successful cloud migration for enterprise organizations.',
    category: 'Cloud',
    author: 'Felix Cloud Team',
    date: '2024-01-10',
    readTime: '8 min',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800&q=80',
  },
  {
    id: 'network-security-best-practices',
    title: 'Network Security Best Practices for 2024',
    excerpt: 'Essential network security practices every organization should implement to protect against modern threats.',
    category: 'Network Security',
    author: 'Felix Network Team',
    date: '2024-01-05',
    readTime: '6 min',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80',
  },
];

// Certifications for Portfolio page
export const certifications = [
  {
    id: 'iso-9001',
    title: 'ISO 9001:2015',
    category: 'Quality',
    description: 'Quality Management System certification ensuring consistent quality in all IT service processes and customer satisfaction.',
    image: 'https://felixinfotech.com/img/iso-1.png',
  },
  {
    id: 'iso-27001',
    title: 'ISO 27001:2013',
    category: 'Security',
    description: 'Information Security Management System certification ensuring the highest standards of data protection and security practices.',
    image: 'https://felixinfotech.com/img/iso-2.png',
  },
  {
    id: 'cisco-partner',
    title: 'Cisco Partner',
    category: 'Partnership',
    description: 'Authorized Cisco partner with certified engineers for networking and security solutions deployment.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Cisco_logo_blue_2016.svg/200px-Cisco_logo_blue_2016.svg.png',
  },
  {
    id: 'fortinet-partner',
    title: 'Fortinet Partner',
    category: 'Partnership',
    description: 'Authorized Fortinet partner with NSE certified engineers for next-gen firewall and security solutions.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Fortinet_logo.svg/200px-Fortinet_logo.svg.png',
  },
  {
    id: 'dell-partner',
    title: 'Dell Technologies Partner',
    category: 'Partnership',
    description: 'Authorized Dell partner for enterprise servers, storage, and compute infrastructure solutions.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Dell_Logo.svg/200px-Dell_Logo.svg.png',
  },
  {
    id: 'hp-partner',
    title: 'HP Partner',
    category: 'Partnership',
    description: 'Authorized HP partner for enterprise computing, printing, and infrastructure solutions.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/200px-HP_logo_2012.svg.png',
  },
  {
    id: 'microsoft-partner',
    title: 'Microsoft Partner',
    category: 'Partnership',
    description: 'Microsoft partner for cloud, productivity, and enterprise software solutions including Azure and M365.',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Microsoft_logo_%282012%29.svg/200px-Microsoft_logo_%282012%29.svg.png',
  },
  {
    id: 'palo-alto-partner',
    title: 'Palo Alto Networks Partner',
    category: 'Security',
    description: 'Authorized partner with PCNSE certified engineers for advanced cybersecurity and threat prevention.',
    image: 'https://customer-assets.emergentagent.com/job_2388931f-8d20-4764-93e0-accef5131585/artifacts/thbn4t2p_image.png',
  },
];
